/**
 * Users API
 *
 * Endpoints related to user actions performed from the client, such as
 * submitting the exit survey upon account deletion.
 */
import { post } from '../core';

/**
 * Submits an exit survey when a user deletes their account
 * @param {Object} surveyData - The exit survey data
 * @returns {Promise<Object>} - The response
 */
export function submitExitSurvey(surveyData) {
  return post('/user/exitSurvey', surveyData);
}

/**
 * Updates user's contact info and/or modal flag
 */
export function updateContactInfo(data) {
  return post('/auth/contact-info', data);
}

export default {
  submitExitSurvey,
  updateContactInfo
}; 